import { configure, extend } from 'vee-validate';
import {
  length, max, regex, required
} from 'vee-validate/dist/rules';
import { isAfter, isBefore, isEqual } from 'date-fns';
import { asDate } from '@/helpers/dateHelpers';

const invalidFormatMessage = 'must have a valid format';

configure({
  classes: {
    invalid: 'is-invalid'
  },
  mode: 'eager'
});

extend('email', {
  // Source: https://www.w3resource.com/javascript/form/email-validation.php
  validate: val => /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    .test(val),
  message: invalidFormatMessage
});

extend('filesHaveNoErrors', {
  validate: value => !value.some(f => f.error),
  message: 'Some files could not be uploaded'
});

/**
 * Validates that the cumulative size of all file attachments
 * does not exceed a specified amount, in MB.
 */
extend('filesMaxTotalSize', {
  validate: (value, { size }) =>
    value.map(f => f.size).reduce((a, c) => a + c) <= (size * 1048576),
  params: ['size'],
  message: 'Total size of files cannot exceed {size}MB'
});

extend('isOnOrAfterOther', {
  params: ['target'],
  validate: (value, { target }) => {
    if (!value || !target) return true;
    const valueAsDate = asDate(value);
    const targetAsDate = asDate(target);
    return isEqual(valueAsDate, targetAsDate) || isAfter(valueAsDate, targetAsDate);
  },
  message: 'must be on or after {target}'
});

extend('isAfterToday', {
  validate: (value) => {
    if (!value) return true;
    const valueAsDate = asDate(value);
    return isAfter(valueAsDate, new Date());
  },
  message: 'must be after today'
});

extend('isBeforeToday', {
  validate: (value) => {
    if (!value) return true;
    const valueAsDate = asDate(value);
    return isBefore(valueAsDate, new Date());
  },
  message: 'must be before today'
});

extend('length', { ...length, message: 'must be exactly {length} characters' });

extend('max', { ...max, message: 'must be no more than {length} characters' });

extend('phone', {
  validate: val => /^\(\d{3}\) \d{3}-\d{4}$/.test(val),
  message: invalidFormatMessage
});

extend('regex', { ...regex, message: invalidFormatMessage });

extend('required', { ...required, message: 'is required' });
